import LoadingSpinner from './loadingSpinner/LoadingSpinner';

export { LoadingSpinner };
export {
  CarIcon,
  AnimatedCircle,
  AnimatedCircleIEFallback
} from './loadingSpinner/styles';
export default LoadingSpinner;
